
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/viewed",
      function () {
        return require("private-next-pages/product/viewed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/viewed"])
      });
    }
  